import axios from 'axios';

// Создаем экземпляр axios с базовыми настройками
const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// API для прогнозов
export const predictionsApi = {
  // Получение списка прогнозов с пагинацией и фильтрацией
  getPredictions: async (params = {}) => {
    try {
      const response = await api.get('/predictions', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching predictions:', error);
      throw error;
    }
  },
  
  // Получение подробной информации о прогнозе по slug
  getPredictionBySlug: async (slug) => {
    try {
      const response = await api.get(`/predictions/${slug}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching prediction with slug ${slug}:`, error);
      throw error;
    }
  },
  
  // Лайк прогноза
  likePrediction: async (id) => {
    try {
      const response = await api.post(`/predictions/like/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error liking prediction with id ${id}:`, error);
      throw error;
    }
  }
};

// API для аккумуляторов (экспрессов)
export const accumulatorsApi = {
  // Генерация аккумулятора
  generateAccumulator: async (matches) => {
    try {
      const response = await api.post('/accumulators/generate', { matches });
      return response.data;
    } catch (error) {
      console.error('Error generating accumulator:', error);
      throw error;
    }
  }
};

// API для бонусов букмекеров
export const bonusesApi = {
  // Получение списка активных бонусов
  getBonuses: async () => {
    try {
      const response = await api.get('/bonuses');
      return response.data;
    } catch (error) {
      console.error('Error fetching bonuses:', error);
      throw error;
    }
  },
  
  // Получение подробной информации о бонусе по slug
  getBonusBySlug: async (slug) => {
    try {
      const response = await api.get(`/bonuses/${slug}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching bonus with slug ${slug}:`, error);
      throw error;
    }
  }
};

// API для руководств по ставкам
export const guidesApi = {
  // Получение списка руководств с пагинацией и фильтрацией
  getGuides: async (params = {}) => {
    try {
      const response = await api.get('/guides', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching guides:', error);
      throw error;
    }
  },
  
  // Получение подробной информации о руководстве по slug
  getGuideBySlug: async (slug) => {
    try {
      const response = await api.get(`/guides/${slug}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching guide with slug ${slug}:`, error);
      throw error;
    }
  }
};

// Объединяем все API для удобного импорта
const apiService = {
  predictions: predictionsApi,
  accumulators: accumulatorsApi,
  bonuses: bonusesApi,
  guides: guidesApi
};

export default apiService; 